export const config = {
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
  useCdn: process.env.NODE_ENV === 'production',
  /**
   * Use a UTC date string
   * https://www.sanity.io/help/js-client-api-version
   */
  apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION || '',
}
